module.exports = __webpack_public_path__ + "media/backgrounds/broken-image-90967cdf.svg";